import React from "react";
import { Table } from "antd";
import { handleOrdering } from "../../utils/ordering";

export function SortableTable({ data, columns, ordering, setOrdering }) {
  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={false}
      showSorterTooltip={{ title: "Clique para ordenar" }}
      onChange={(pagination, filters, sorter) =>
        handleOrdering(sorter, ordering, setOrdering)
      }
    />
  );
}
